export const ONBOARD_TEXT = "Click here to install Fetch.AI Wallet!";
export const CONNECT_TEXT = "Connect";
export const CONNECTED_TEXT = "Connected";
export const DISCONNECT_TEXT = "Disconnect";
